/* eslint-env browser */

import * as React from 'react';
// @ts-ignore
import DeckGL from '@deck.gl/react';
// @ts-ignore
import {PathStyleExtension} from '@deck.gl/extensions';
import { EditableGeoJsonLayer } from '@nebula.gl/layers';
import { ModifyMode } from '@nebula.gl/edit-modes';
import {_MapContext as MapContext} from 'react-map-gl';
import {IFeature_CONO} from "../types";

const featureCollectionBase = {
    type: 'FeatureCollection',
    features: [
        /* insert features here */
    ]
};

export interface IEditableLayerProps {

}

export function EditableLayer ({temporaryFeatures, viewport, editMode, update, onEditStart, onEditEnd}: any) {
    const features = React.useRef<IFeature_CONO[]>(temporaryFeatures);
    const [featureCollection, setFeatureCollection] = React.useState({
        "type": "FeatureCollection",
        "features": temporaryFeatures.slice(),
    });
    const [selectedFeatureIndexes] = React.useState([0]);
    // @ts-ignore
    const [mode] = React.useState(() => ModifyMode);
    const [_editMode, setEditMode] = React.useState('');
    const onEdit = React.useCallback(({updatedData, editType}) => {
        if (editType === 'movePosition') {
            // start editing
            onEditStart();
        }
        if (editType === 'finishMovePosition') {
            // finish editing
            onEditEnd();
        }
        setFeatureCollection(updatedData);
        update(updatedData.features);
    }, [setFeatureCollection, onEditEnd, onEditStart, update]);
    const getFillColor = React.useCallback(
        () => [88, 178, 255, 200],[]);
    const getEditHandlePointColor = React.useCallback(
        ({ type }) => [255, 0, 0, 200],[]);
    const getEditHandlePointRadius = React.useCallback(
        () => 300,[]);
    const viewState = React.useMemo(() => {
        const {longitude, latitude, zoom} = viewport;
        return {longitude, latitude, zoom};
    }, [viewport]);

    const dashArray = React.useMemo(() => ([3,2]), []);

    const extensions = React.useMemo(() =>
        ([new PathStyleExtension({dash: true})]),
    []);

    React.useEffect(() => {
        if (editMode !== _editMode) {
            setEditMode(editMode);
            setFeatureCollection({ ...featureCollectionBase, features: temporaryFeatures });
        }

        if (features && features?.current.length === 0) {
            setFeatureCollection({ ...featureCollectionBase, features: temporaryFeatures });
        }

        if (features && features?.current.length !== 0 &&
            temporaryFeatures.length !== 0 &&
            temporaryFeatures[0].properties &&
            temporaryFeatures[0].properties.update === true
        ) {
            setFeatureCollection({ ...featureCollectionBase, features: temporaryFeatures });
        }
    }, [temporaryFeatures, features, setFeatureCollection, editMode, _editMode]);

    // @ts-ignore
    const layer = new EditableGeoJsonLayer({
        data: featureCollection,
        mode,
        selectedFeatureIndexes,
        onEdit,
        getFillColor: [88, 178, 255, 200] || getFillColor,
        getEditHandlePointColor,
        editHandlePointStrokeWidth: 0,
        editHandlePointOutline: false,
        getEditHandlePointRadius,
        getDashArray: dashArray,
        dashJustified: true,
        extensions,
    } as any);

    return (
        <>
            <DeckGL
                ContextProvider={MapContext.Provider}
                viewState={viewState}
                width={'100%'}
                height={'100%'}
                controller={{
                    doubleClickZoom: false,
                    scrollZoom: false,
                } as any}
                layers={[layer]}
                // getCursor={layer.getCursor.bind(layer)}
            >
            </DeckGL>
        </>
    );
}
